export const MINDBOX_OPERATIONS = {
    addToCart: 'Website.SetCart',
    addToFavourite: 'Website.SetWishList',
    deleteFromCart: 'Website.ClearCart',
    deleteFromFavourite: 'Website.ClearWishList',
    viewCategory: 'Website.ViewCategory',
    viewProduct: 'Website.ViewProduct',
} as const;
